<div
  class="toolbar-item-content bg-grey-hover-10 radius-8 is-cursor-pointer"
  [class.text-blue]="selected()"
  [class.bg-blue-10]="selected()"
>
  <ng-content />
</div>

@if (label()) {
  <div class="label is-flex is-absolute is-fullheight bg-grey-0 radius-8" [class.hover]="hover()">
    <app-text class="is-family-medium" [text]="label()" />
  </div>
}
